﻿<template>

    <article class="tc-card" :class="{ 'is-disabled': !bookable(), 'is-in-cart': InCart }" :data-tour-id="tour_details?.tour_id">
        <button type="button" class="tc-media" :aria-label="(bookable() ? 'Book ' : 'View details of ') + getSalesGroupName(tour_details)" @click="bookable() ? tour_selected() : tour_see_details(tour_details.tour_id)">
            <v-lazy-image class="tc-image" :src="image()" :alt="imageAltText()"/>
            <img v-if="getBrandLogo()" class="tc-brand-logo" :src="getBrandLogo()" alt="" />
            <span v-if="isAAT() && isAgent_Login() && Mapping_Codes()" class="tc-mapping">{{Mapping_Codes()}}</span>
            <span v-if="Includes_Accommodation()" class="tc-badge is-accent tc-media-accommodation">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 18v-6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6M3 14h18M7 10V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3" /></svg>
                Accommodation included
            </span>
            <span class="tc-badges">
                <span v-if="Has_Length()" class="tc-badge">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                    {{ isAAT() ? duration() : durationInDays() }}
                </span>
                <span v-if="Departure_City()" class="tc-media-location tc-badge-end">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" /><circle cx="12" cy="10" r="2.5" /></svg>
                    <span class="tc-media-location-label">Departs</span>
                    <span class="tc-media-location-city">{{ Departure_City() }}</span>
                </span>
            </span>
        </button>

        <div class="tc-body">
            <h3 class="tc-title">
                <a class="cardTitle" :data="tour_details?.tour_id" @click="bookable() ? tour_selected() : tour_see_details(tour_details.tour_id)">{{getSalesGroupName(tour_details)}}</a>
            </h3>
            <p class="tc-desc">{{ display_description() }}</p>
        </div>

        <footer class="tc-foot">
            <div v-if="bookable()" class="tc-price">
                <span class="tc-price-label">From</span>
                <strong>{{ price() }}</strong>
                <small>{{ currency() }}</small>
            </div>
            <p v-else class="tc-unavailable">{{ getNotBookableText() }}</p>

            <div class="tc-actions">
                <button type="button" class="tc-link" @click="tour_see_details(tour_details.tour_id)">Tour details</button>
                <template v-if="bookable()">
                    <router-link v-if="InCart" to="/cart" class="tc-in-cart">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                        In your cart
                    </router-link>
                    <button v-else type="button" class="button button-standard xsmall tc-book" @click="tour_selected()">Book now</button>
                </template>
            </div>
        </footer>
    </article>

    <div class="slideout" :hidden="isHidden" style="z-index: 201 !important;">
        <div class="slideout-inner">
            <button class="close no-bg" aria-label="Close" @click="isHidden = true"></button>

            <div class="slideout-content">
                <itinerary :tour_id="tour_details?.tour_id" :banner="true" ref="itinerary" v-if="!isHidden"></itinerary>
            </div>

        </div>

        <div class="slideout-bg" @click="isHidden = true"></div>

    </div>

    <!-- No longer used: the OpenBooking prop is never passed by any parent, so this loading pane never shows.
         Opening a tour from the URL (?open=) is handled by 1_search.ts (maybeOpenFromQueryOnce).
    <div class="slideout" v-if="loadingOpenTour" 
         x-transition:enter="transition ease-out duration-500 -mr-64"
         x-transition:enter-start=""
         x-transition:enter-end="transform -translate-x-64"
         x-transition:leave="transform ease-out duration-75"
         x-transition:leave-start=""
         x-transition:leave-end="transform translate-x-64"
         style="z-index: 201 !important;">
        <div class="slideout-inner">
            <button class="close no-bg" @click="isHidden = true"></button>

            <div class="pb-60" >
                <div class="w-2/3 float-left  px-5">
                    <h3 class="tourTitle">{{getSalesGroupName(tour_details)}}</h3>
                    <p class="mt-0">{{display_description()}}</p>
                </div>  
                <div class="w-1/3 float-left py-8 px-5">
                    <img class="image rounded" :src="imageSmall()" :alt="imageAltText()">
                </div>
            </div>

            <button type="button" class="button button-pink-book full mx-30 my-5p-10">
                <svg class="animate-spin h-5 w-5 mr-3 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 512 512" stroke="currentColor">
                    <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z" class=""></path>
                </svg>
                Loading Tour
            </button>
        </div>

    </div>
    -->

</template>

<script lang="ts" src="./tour_card.ts"></script>